import { money, fmtDate } from "@/lib/api";

const Lines = ({ items }) => items.filter(Boolean).map((l, i) => <div key={i}>{l}</div>);

export const InvoicePaper = ({ inv, logoUrl }) => {
  const co = inv.company || {}, cl = inv.client || {};
  return (
    <div id="invoice-paper" data-testid={`invoice-detail-view-${inv.id}`}
      className="print-area bg-white text-slate-900 rounded-xl border border-border shadow-sm p-6 sm:p-10 font-sans">
      <div className="flex flex-col sm:flex-row justify-between gap-6">
        <div>
          {logoUrl ? <img src={logoUrl} alt={co.business_name} data-testid="invoice-detail-logo" className="max-h-20 max-w-[220px] object-contain object-left mb-4" /> : null}
          {inv.status === "void" && <div className="inline-block border-4 border-red-500 text-red-500 font-heading font-extrabold text-2xl px-3 py-1 rounded-lg -rotate-6 mb-3 tracking-widest" data-testid="invoice-void-stamp">VOID</div>}
          <h1 className="font-heading text-3xl font-extrabold tracking-tight">INVOICE</h1>
          <div className="mt-4 text-sm leading-relaxed">
            <div className="font-bold text-base">{co.business_name || "Your Business"}</div>
            <Lines items={[co.address, co.phone, co.email]} />
          </div>
        </div>
        <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm sm:text-right sm:justify-items-end self-start">
          <span className="text-xs font-bold uppercase tracking-wider text-slate-500 self-center">Invoice #</span>
          <span className="font-mono font-bold" data-testid="invoice-detail-number">{inv.invoice_number}</span>
          <span className="text-xs font-bold uppercase tracking-wider text-slate-500 self-center">Date</span>
          <span data-testid="invoice-detail-date">{fmtDate(inv.date)}</span>
          <span className="text-xs font-bold uppercase tracking-wider text-slate-500 self-center">Due</span>
          <span>{inv.due_date ? fmtDate(inv.due_date) : "Upon receipt"}</span>
        </div>
      </div>
      <div className="h-0.5 bg-emerald-600 my-6" />
      <div className="text-sm">
        <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-1">Bill to</div>
        <div className="font-bold text-base">{cl.name}</div>
        <Lines items={[cl.address, cl.email, cl.phone]} />
      </div>
      <table className="w-full mt-8 text-sm">
        <thead>
          <tr className="border-b-2 border-slate-900 text-xs font-bold uppercase tracking-wider text-slate-500">
            <th className="text-left py-2">Description</th>
            <th className="text-right py-2 w-16">Qty</th>
            <th className="text-right py-2 w-24">Rate</th>
            <th className="text-right py-2 w-28">Amount</th>
          </tr>
        </thead>
        <tbody>
          {inv.line_items.map((it, i) => (
            <tr key={i} className="border-b border-slate-200">
              <td className="py-3">{it.description}</td>
              <td className="py-3 text-right font-mono">{it.quantity}</td>
              <td className="py-3 text-right font-mono">{money(it.unit_price)}</td>
              <td className="py-3 text-right font-mono">{money(it.quantity * it.unit_price)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex justify-end mt-4">
        <div className="w-full sm:w-72 text-sm space-y-1.5">
          <div className="flex justify-between"><span className="text-slate-500">Subtotal</span><span className="font-mono">{money(inv.subtotal)}</span></div>
          <div className="flex justify-between"><span className="text-slate-500">Tax ({inv.tax_rate}%)</span><span className="font-mono">{money(inv.tax_amount)}</span></div>
          <div className="flex justify-between items-baseline border-t-2 border-slate-900 pt-2 mt-2">
            <span className="font-bold">Total Due</span>
            <span className="font-mono font-bold text-2xl text-emerald-600" data-testid="invoice-detail-total">{money(inv.total)}</span>
          </div>
        </div>
      </div>
      {inv.notes && (
        <div className="mt-8 text-sm">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-1">Notes / Terms</div>
          <p className="whitespace-pre-line text-slate-700">{inv.notes}</p>
        </div>
      )}
      <p className="mt-8 text-sm text-slate-500">Thank you for your business.</p>
    </div>
  );
};
